

import { useState } from "react"
import { Header } from "../../../IndexPage/Header/Header"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Footer } from "../../../Footer/Footer"


export const CargoInsurance = () => {

    const [ReadMoreText, setReadMoreText] = useState(false)

    const handleReadmore = () => {
        setReadMoreText(!ReadMoreText)
    }

    return (
        <>
         <div className="container-fluid">
            <div className="row" onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="CargoInsurance" />
                    <HerosectionsAll ScreenName="Cargo Insurance" ScreenSearch="Indemnity" />
                    <div className="row p-2 p-lg-5" >

                        <div className="col-12 col-lg-12 py-5">
                            <div className="p-4 faint " style={{ position: 'relative' , textAlign: 'justify' }}>
                                <h5 className="fw-bold gray_color">Marine Cargo Insurance</h5>

                                <p>With the rapid globalization, international business, across the boundaries of countries is growing by leaps & bounds! One of the parameters which all business has to take a call while planning and designing the supply chain is the transportation of goods. Cargo Insurance takes care of the transit risks associated with the transportation. When we say marine cargo insurance it does include all mode of transit of the goods I,e, sea, Air, Road, Rail, Post Parcel etc.</p>
                                <p> Cargo insurance operates in the business environment consisting various parties such as Importers, Exporters, Shipowners, Charters, Freight Forwarders Bankers, Insurance Companies and so the documentations involved is also substantial.</p>

                                <p>Due to its international character, cargo insurance also operates in the legal environment consisting of Marine Insurance Act, Carriage of Goods Act, Rail way Act, Multimodal Transport, International conventions and so on.</p>

                                <p>With Advance techniques and technologies there is a sea change in the world of transportation and so the innovation in the coverages of cargo insurance. Standard wordings to tailormade wordings of the sales contracts, requires specialized insurance coverages during the transportation and storage of the goods during transit. Underwriters developed specialized coverages such as stock throughput, Delay in Start Up for project cargo & various liability policies covering various liabilities associated with marine risks. </p>
                                {ReadMoreText && (
                                    <div>
                                        <p>
                                            In considering the various dimensions of the risk, underwriters’ emphasis on evaluation of the risk, keep an eye on accumulation of risks and also educate their clients for risk prevention and minimization measures to keep their Incurred Claim Ratio under control.
                                        </p>
                                        <p>Understanding the sales contract, Institute Cargo Clauses, policy conditions, and warranties is the fundamental for understanding a Cargo insurance contract. Drafting of Cargo Insurance Contract is critical and vital for a smooth claim settlement of the transit claims.</p>

                                        <p> “Team MILSO” is committed towards helping to understand the intricacies involved in the drafting of Cargo Insurance Contract, Interpretation of various Institute Cargo Clauses, application of conditions & warranties, measure of Indemnity, by referring to the case laws wherever applicable.  </p>
                                        <p>So let us select the “Contents on Board” and be a part of this “Maritime Adventure”!!</p>
                                    </div>

                                )}


                                <p className="float-end read_more_btn pb-lg-3">
                                    <button className="btn button" onClick={handleReadmore}>
                                        <span>{ReadMoreText ? 'Read Less' : 'Read More'}</span>
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            </div>
        </>
    )
}



